__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-odometer/v3_1_2/";